import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
import { useLoaderData } from "react-router-dom";
import logoFallback from "../../../assets/digited_logo.png";
import logoMobileFallback from "../../../assets/logoMobile.png";
import { Link, Logo } from "../../../components";
import { useAuthStore, useNavbarStore } from "../../../stores";
import { getEnvironmentVariables, getPageTitle } from "../../../utils/general";

export function LinkLogo({ authenticated }: { authenticated: boolean }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const userMgmtData = useLoaderData() as { id: number, name: string, splash?: string};

  const setNavbarItem = useNavbarStore(state => state.setNavbarItem);
  const smartConfiguration = useAuthStore(state => state.smartConfiguration);

  const {
    altLogoName,
    digitedLogo,
    digidetLogoMobile,
    digitedLogoHeight,
    mobileLogoHeight
  } = getEnvironmentVariables();

  let logoHeight = "32px";
  if (isMobile){
    logoHeight = mobileLogoHeight ? mobileLogoHeight + "px" : "32px";
  }else{
    logoHeight = digitedLogoHeight ? digitedLogoHeight + "px" :
      smartConfiguration?.logoHeight ? smartConfiguration.logoHeight + "px" : "32px";
  }
  const headerLink = smartConfiguration?.visForyou === false ? "/esplora" : "/per-te";

  const pageTitle = getPageTitle(authenticated ? headerLink : "/login")?.toLowerCase() ?? "";
  const logoName = altLogoName?.trim() || userMgmtData.name;
  const logoLabel = `Logo ${logoName}${pageTitle ? ` - ${t("back_to_page")} ${pageTitle}` : ""}`;

  return (
    <Link
      tabIndex={ 0 }
      sx={ {
        "&:focus": {
          outline: "none"
        },
        "&:focus-visible": {
          outline: `2px solid ${theme.customColors.headerIcon}`,
          outlineOffset: "2px"
        },
        display: "inline-block",
        lineHeight: 0
      } }
      aria-label={ logoLabel }
      href={ authenticated ? headerLink : "/logout" }
      onClick={ ()=> { authenticated && setNavbarItem("FOR_YOU") } }
      zIndex={ theme.zIndex.fab }
    >
      <Logo
        tabIndex={ -1 }
        alt={ logoLabel }
        width="auto"
        aria-hidden="true"
        height={ logoHeight }
        src={ isMobile ? digidetLogoMobile ?? logoMobileFallback : digitedLogo ?? logoFallback }
      />
    </Link>
  );
}
